export const issueDescriptorConstants = {
    PRIORITY: 'desc/priority',
    STATUS: 'desc/status',
    TYPE: 'desc/type'
}